import { useSearchParams } from 'react-router-dom';
import './MembershipPaymentSuccessStripe.css';
import { useState } from 'react';
import { triggerMembershipSync } from '../../services/membership.service';

const isMobileDevice = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

export function MembershipPaymentSuccess() {
   const [searchParams] = useSearchParams();
   const membershipType = searchParams.get('membershipType') || undefined;
   const membershipName = searchParams.get('membershipName') || undefined;
   const trialPeriodDaysRaw = searchParams.get('trialPeriodDays');
   const trialPeriodDays = Number.isFinite(Number(trialPeriodDaysRaw)) && Number(trialPeriodDaysRaw) > 0 ? Number(trialPeriodDaysRaw) : 0;
   const email = searchParams.get('email') || undefined;
   const name = searchParams.get('name') || undefined;
   const [isMobile] = useState(() => isMobileDevice());

   const prettyMembership = membershipName || membershipType || 'GolfN';

   const handleRedirectToApp = async () => {
      triggerMembershipSync();
      window.location.href = 'golfn://home';
   };

   const handleOpenApp = () => {
      triggerMembershipSync();
      window.location.href = 'golfn://home';
      setTimeout(() => {
         if (/Android/i.test(navigator.userAgent)) {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.golfn.app';
         } else {
            window.location.href = 'https://apps.apple.com/app/golfn/id6502394298';
         }
      }, 1500);
   };

   return (
      <div className="stripe-success-root">
         <div className="stripe-success-card">
            <div className="stripe-checkmark">
               <svg
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle
                     cx="12"
                     cy="12"
                     r="12"
                     fill="#00b86b"
                  />
                  <path
                     fill="none"
                     stroke="#fff"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     d="M7 13l3 3 7-7"
                  />
               </svg>
            </div>

            <h1 className="stripe-title">Membership Successfully Activated</h1>
            <p
               className="stripe-message"
               style={{ marginLeft: '-15px' }}>
               <span className="stripe-emoji">🏌️‍♂️</span> You just upgraded your game{name ? `, ${name}` : ''}!
            </p>

            {email && <p className="stripe-summary-line">{email}</p>}

            <div className="stripe-summary">
               {trialPeriodDays > 0 ? (
                  <p className="stripe-summary-line">
                     Your <strong>{trialPeriodDays}-day free trial</strong> is live.
                  </p>
               ) : (
                  <p className="stripe-summary-line">Your membership is live.</p>
               )}
               <p className="stripe-summary-line">
                  Enjoy <span className="stripe-summary-line-strong">{prettyMembership}</span> perks & earn more points every round.
               </p>
            </div>

            <div className="stripe-actions">
               <a
                  onClick={handleRedirectToApp}
                  className="stripe-btn-primary">
                  Start Playing
               </a>
               {isMobile && (
                  <a
                     onClick={handleOpenApp}
                     className="stripe-btn-open-app">
                     Open App
                  </a>
               )}
            </div>

            <p className="stripe-hint">It may take up to 30 seconds for your membership to appear in the app. If you don't see it, try closing and reopening the GolfN app.</p>
         </div>
      </div>
   );
}
